export default __webpack_public_path__ + "static/media/none.1af1c476.webp";